import { queryClient } from "Utils/queryClient";
import { useMutation } from "@tanstack/react-query";
import { NotificationApiV2 } from "Data/Notification.api.v2";
import { PREFERENCES_EMAIL_QUERY_KEY } from "Data/keys/QueryKeys";
import {
  IPreferencesRequest,
  IPreferences
} from "Data/interfaces/Preferences/IPreferencesApi";
import toastHandler from 'Utils/toastHandler';

export const useQueryCreatePlottingPreferenceEmail = () => {
  const { mutate, mutateAsync, isPending } = useMutation({
    mutationFn: (variables: IPreferencesRequest) => {
      return NotificationApiV2.createPlottingPreferencesEmail(variables);
    },
    onMutate: async (variables) => {
      const previousPlottingPreferencesEmail = queryClient.getQueryData<IPreferences[]>(
        [PREFERENCES_EMAIL_QUERY_KEY]
      );
      queryClient.setQueryData<IPreferences[]>(
        [PREFERENCES_EMAIL_QUERY_KEY],
        (oldData) => {
          if (oldData) {
            return oldData.map(item => {
              if (item.Action === variables.action) {
                return {
                  ...item,
                  Preference: variables.preference
                };
              }
              return item;
            });
          }
          return oldData;
        }
      );
      return { previousPlottingPreferencesEmail };
    },
    onError: async (e: any, _variables, context) => {
      await queryClient.cancelQueries({ queryKey: [PREFERENCES_EMAIL_QUERY_KEY] });
      queryClient.setQueryData(
        [PREFERENCES_EMAIL_QUERY_KEY],
        context?.previousPlottingPreferencesEmail
      );
      const msg = 'Erro ao editar preferência de plotagem de email';
      const error = e.errors ? (e.errors[0]?.Message || msg) : msg;
      toastHandler.showError(error);
    }
  });

  return {
    createPlottingPreferenceEmail: mutate,
    createPlottingPreferenceEmailAsync: mutateAsync,
    isLoading: isPending,
  };
};
